<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de documento</option>
        <option v-for="TipoDocEquitas in TiposMensajeria" :value="TipoDocEquitas.TipoDocId">{{TipoDocEquitas.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        TiposMensajeria:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      parametros: Object,
      idDelInput:String
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoMensajeria", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    computed: {
      //(:3 000)
    },//Computed
    methods: {
    CargarTiposMensajeria(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.TiposMensajeria, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.TiposMensajeria = respuesta.data._TiposDocEquitas;
              this.idDelModelo = this.TiposMensajeria[0].TipoDocId;
              this.cambiaMensajeriaInicial();
              return this.TiposMensajeria;
            }
          }).catch(e => {
            console.log(e);
         });
    },
    cambiarDatos: function (event) {
        this.idDelModelo = event.target.value;
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoMensajeria", { llave: this.idDelInput, valor: event.target.value});
        this.$emit("valorParaElPadre", event);
      },
      cambiaMensajeriaInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerTipoMensajeria", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },//Methods
    created() {
      this.CargarTiposMensajeria();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/TiposMensajeria.vue